import parse, { HTMLReactParserOptions } from 'html-react-parser';

export const isString = (value: unknown) => typeof value === 'string';

export const parseString = (string: string, options?: HTMLReactParserOptions) =>
  parse(string ?? '', options);

export const formatString = (string: string, wordToReplace: string) => {
  return string
    .toLowerCase()
    .replace(wordToReplace, '')
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};
